'use client';
// src/components/layout/GiftCardsNav.tsx — пункт навбару "Подарункові картки"
// з hover-дропдауном категорій (categoryName → топ-бренди). CSS :hover (SSR-safe).
import { useState, useEffect } from 'react';
import Link from 'next/link';

type Cat = { category: string; sections: string[]; total: number };

export function GiftCardsNav({ href, label }: { href: string; label: string }) {
  const [cats, setCats] = useState<Cat[]>([]);
  useEffect(() => {
    let on = true;
    fetch('/api/more?menu=1').then(r => (r.ok ? r.json() : null)).then(d => { if (on && d?.categories) setCats(d.categories); }).catch(() => {});
    return () => { on = false; };
  }, []);

  return (
    <div className="hdr-gc">
      <Link href={href} className="hdr-nav-link" prefetch={true}>{label}</Link>
      {cats.length > 0 && (
        <div className="hdr-gc-menu">
          <div className="hdr-gc-grid">
            {cats.map(c => (
              <div key={c.category} className="hdr-gc-col">
                <Link href={`${href}?category=${encodeURIComponent(c.category)}`} className="hdr-gc-cat">{c.category}</Link>
                {c.sections.map(s => (
                  <Link key={s} href={`${href}?section=${encodeURIComponent(s)}`} className="hdr-gc-brand">{s}</Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
